import * as Yup from "yup";

export const dataModel = {
  dateSend: null,
};

export const validationDataModel = (edit) => {
  return Yup.object().shape({
    dateSend: Yup.date().required("forms.validations.required"),
  });
};

export const setInitialValues = (initialValues) => {
  if (initialValues && Object.keys(initialValues).length > 0) {
    return initialValues;
  }
  return dataModel;
};
